// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"637":"bfdeb495","872":"aa134bd6"}[chunkId] + ".chunk.js";
};